// GENERADO por `npm run brain:clients` a partir de shared/brain-clients/*.json — NO editar a mano.
// Vista PÚBLICA del registro (id, nombre, preguntas sugeridas): es lo único que importa el frontend.
// Lo demás (canales, secretos, BigQuery, HubSpot) vive en index.ts y NO entra al bundle del front.
import type { BrainClientPublic } from '../brain-client-config';

export const BRAIN_CLIENT_PUBLIC: Readonly<Record<string, BrainClientPublic>> = {
  "airpak": {
    "id": "airpak",
    "displayName": "Airpak"
  },
  "airtm": {
    "id": "airtm",
    "displayName": "Airtm"
  },
  "alsea": {
    "id": "alsea",
    "displayName": "Alsea"
  },
  "amazon": {
    "id": "amazon",
    "displayName": "Amazon"
  },
  "aprende-institute": {
    "id": "aprende-institute",
    "displayName": "Aprende Institute"
  },
  "bancolombia": {
    "id": "bancolombia",
    "displayName": "Bancolombia"
  },
  "bancor": {
    "id": "bancor",
    "displayName": "Bancor"
  },
  "batistella": {
    "id": "batistella",
    "displayName": "Batistella"
  },
  "bayer": {
    "id": "bayer",
    "displayName": "Bayer"
  },
  "beiersdorf": {
    "id": "beiersdorf",
    "displayName": "Beiersdorf"
  },
  "brkaway": {
    "id": "brkaway",
    "displayName": "Brkaway"
  },
  "ccu": {
    "id": "ccu",
    "displayName": "CCU"
  },
  "cinemark": {
    "id": "cinemark",
    "displayName": "Cinemark"
  },
  "coca-cola": {
    "id": "coca-cola",
    "displayName": "Coca-Cola"
  },
  "coinbase": {
    "id": "coinbase",
    "displayName": "Coinbase"
  },
  "comunapp": {
    "id": "comunapp",
    "displayName": "Comunapp"
  },
  "coppel": {
    "id": "coppel",
    "displayName": "Coppel"
  },
  "crocs": {
    "id": "crocs",
    "displayName": "Crocs"
  },
  "despegar": {
    "id": "despegar",
    "displayName": "Despegar"
  },
  "didi": {
    "id": "didi",
    "displayName": "DiDi"
  },
  "disney": {
    "id": "disney",
    "displayName": "Disney"
  },
  "dolfintech": {
    "id": "dolfintech",
    "displayName": "Dolfintech",
    "questions": {
      "es": [
        "¿Cuál es el revenue forecast de Dolfintech?",
        "¿Qué discusiones hubo en onboarding?",
        "¿En qué estado están las implementaciones?",
        "Armá un resumen del estado de Dolfintech"
      ],
      "en": [
        "What is the revenue forecast for Dolfintech?",
        "What discussions happened during onboarding?",
        "What is the status of the implementations?",
        "Summarize the current status of Dolfintech"
      ],
      "pt": [
        "Qual é a previsão de receita da Dolfintech?",
        "Quais discussões ocorreram durante o onboarding?",
        "Qual é o status das implementações?",
        "Resuma o status atual da Dolfintech"
      ]
    }
  },
  "editora-globo": {
    "id": "editora-globo",
    "displayName": "Editora Globo"
  },
  "elevva": {
    "id": "elevva",
    "displayName": "Elevva"
  },
  "etermax": {
    "id": "etermax",
    "displayName": "Etermax"
  },
  "falabella": {
    "id": "falabella",
    "displayName": "Falabella"
  },
  "familhao": {
    "id": "familhao",
    "displayName": "Familhão"
  },
  "fravega": {
    "id": "fravega",
    "displayName": "Frávega"
  },
  "globoplay": {
    "id": "globoplay",
    "displayName": "Globoplay"
  },
  "grupo-jcpm": {
    "id": "grupo-jcpm",
    "displayName": "Grupo JCPM"
  },
  "hogares-union": {
    "id": "hogares-union",
    "displayName": "Hogares Unión (HU)",
    "questions": {
      "es": [
        "¿Cómo viene el proyecto de Hogares Unión?",
        "¿Qué se decidió en los canales de martech y Owned Media?",
        "¿Qué equipos están involucrados y qué hace cada uno?",
        "¿Cuál es el revenue de Hogares Unión contra el plan?",
        "Armá un resumen del estado de Hogares Unión"
      ],
      "en": [
        "How is the Hogares Unión project going?",
        "What was decided in the martech and Owned Media channels?",
        "Which teams are involved and what does each one do?",
        "What is Hogares Unión's revenue against plan?",
        "Summarize the current status of Hogares Unión"
      ],
      "pt": [
        "Como está o projeto da Hogares Unión?",
        "O que foi decidido nos canais de martech e Owned Media?",
        "Quais equipes estão envolvidas e o que cada uma faz?",
        "Qual é a receita da Hogares Unión em relação ao plano?",
        "Resuma o status atual da Hogares Unión"
      ]
    }
  },
  "indeed": {
    "id": "indeed",
    "displayName": "Indeed"
  },
  "kavak": {
    "id": "kavak",
    "displayName": "Kavak"
  },
  "kimberly-clark": {
    "id": "kimberly-clark",
    "displayName": "Kimberly-Clark"
  },
  "laika": {
    "id": "laika",
    "displayName": "Laika"
  },
  "latam": {
    "id": "latam",
    "displayName": "LATAM Airlines",
    "questions": {
      "es": [
        "¿Cuál es el revenue forecast de LATAM este trimestre?",
        "¿Qué se discutió en los canales de estrategia?",
        "¿Cuáles son los principales feedbacks del NPS?",
        "Armá un resumen ejecutivo de LATAM Airlines"
      ],
      "en": [
        "What is the revenue forecast for LATAM this quarter?",
        "What was discussed in the strategy channels?",
        "What are the main NPS feedback points?",
        "Create an executive summary of LATAM Airlines"
      ],
      "pt": [
        "Qual é a previsão de receita da LATAM neste trimestre?",
        "O que foi discutido nos canais de estratégia?",
        "Quais são os principais feedbacks do NPS?",
        "Crie um resumo executivo da LATAM Airlines"
      ]
    }
  },
  "loreal": {
    "id": "loreal",
    "displayName": "L'Oréal"
  },
  "lulobank": {
    "id": "lulobank",
    "displayName": "Lulo Bank"
  },
  "meli": {
    "id": "meli",
    "displayName": "Mercado Libre"
  },
  "moov": {
    "id": "moov",
    "displayName": "Moov"
  },
  "naranja-x": {
    "id": "naranja-x",
    "displayName": "Naranja X"
  },
  "natura": {
    "id": "natura",
    "displayName": "Natura"
  },
  "nestle": {
    "id": "nestle",
    "displayName": "Nestlé"
  },
  "nomad": {
    "id": "nomad",
    "displayName": "Nomad"
  },
  "nubank": {
    "id": "nubank",
    "displayName": "Nubank"
  },
  "nutresa": {
    "id": "nutresa",
    "displayName": "Nutresa"
  },
  "palacio-de-hierro": {
    "id": "palacio-de-hierro",
    "displayName": "Palacio de Hierro"
  },
  "parque-arauco": {
    "id": "parque-arauco",
    "displayName": "Parque Arauco"
  },
  "pedidosya": {
    "id": "pedidosya",
    "displayName": "PedidosYa"
  },
  "petlove": {
    "id": "petlove",
    "displayName": "Petlove"
  },
  "pg": {
    "id": "pg",
    "displayName": "P&G"
  },
  "portfolio": {
    "id": "portfolio",
    "displayName": "Portfolio por Segmento",
    "pseudo": true
  },
  "primax": {
    "id": "primax",
    "displayName": "Primax"
  },
  "rabbit": {
    "id": "rabbit",
    "displayName": "Rabbit"
  },
  "rappi": {
    "id": "rappi",
    "displayName": "Rappi"
  },
  "rotoplas": {
    "id": "rotoplas",
    "displayName": "Rotoplas"
  },
  "scholas": {
    "id": "scholas",
    "displayName": "Scholas"
  },
  "shell": {
    "id": "shell",
    "displayName": "Shell"
  },
  "simoniz": {
    "id": "simoniz",
    "displayName": "Simoniz"
  },
  "strix": {
    "id": "strix",
    "displayName": "Strix"
  },
  "tec-de-monterrey": {
    "id": "tec-de-monterrey",
    "displayName": "Tec de Monterrey"
  },
  "telecom": {
    "id": "telecom",
    "displayName": "Telecom"
  },
  "televia": {
    "id": "televia",
    "displayName": "Televía"
  },
  "tenpo": {
    "id": "tenpo",
    "displayName": "Tenpo"
  },
  "uber": {
    "id": "uber",
    "displayName": "Uber"
  },
  "unilever": {
    "id": "unilever",
    "displayName": "Unilever"
  },
  "universidad-siglo-21": {
    "id": "universidad-siglo-21",
    "displayName": "Universidad Siglo 21"
  },
  "visa": {
    "id": "visa",
    "displayName": "Visa"
  },
  "vix": {
    "id": "vix",
    "displayName": "VIX"
  },
  "yoy": {
    "id": "yoy",
    "displayName": "YOY"
  },
};

export const BRAIN_CLIENT_IDS: readonly string[] = Object.keys(BRAIN_CLIENT_PUBLIC);
